<template>
    <fa icon="edit" />
</template>

<script>


export default {
    name: 'editIcon',
    props: ['tooltipText'],
    emits: [],
    components: {
    },
    data: function() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },

}
</script>

<style scoped>
</style>


